






import { Component, Vue } from 'vue-property-decorator'
import StampRallyShow from '@/components/stamp_rally/StampRallyShow.vue'

import { mapGetters } from 'vuex'

@Component({
  components: { StampRallyShow },
  computed: {},
})
export default class StampRally extends Vue {}
